import React from 'react'
import { Text } from '@eltoro-ui/components'
import './LensFilterContainer.scss'

export const LensFilterContainer: React.FC<{}> = ({ children }) => (
  <div className="LensFilterContainer">{children}</div>
)
